<template>
  <div :class="isFixed ? 'isFixed':''">
    <svg-icon class="icon-show" :icon-class="isFullscreen ? 'exit-fullscreen' : 'fullscreen'" @click="toggle" />
  </div>
</template>

<script setup>
import { useFullscreen } from '@vueuse/core'

const props = defineProps({
  isFixed: Boolean
})

const { isFullscreen, enter, exit, toggle } = useFullscreen();
</script>

<style lang='scss' scoped>
.isFixed {
  position: fixed;
  z-index: 1000;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  .icon-show {
    display: none;
  }
}
.isFixed:hover {
  .icon-show {
    display: block !important;
  }
}
.screenfull-svg {
  display: inline-block;
  cursor: pointer;
  fill: #5a5e66;
  width: 20px;
  height: 20px;
  vertical-align: 10px;
}
</style>